<template>

    <!--================ Title Menu Area =================-->

    <div class="pu_title">
        <div class="pu_row">
            <div class="pu_contents">
                <ul>
                    <li>
                        <a>
                            <i class="fas fa-home"></i>
                        </a>
                    </li>
                    <li>
                        <a>{{ getBase.adminMenuName_1d }}</a>
                    </li>
                    <li>
                        <a>{{ getBase.adminMenuName_2d }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!--================ //Title Menu Area =================-->

</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        }

        ,data() {
            return {

                THIS_NAME: "INC TITLE",

            };
        },

        methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , init() {

            },

        },

        beforeCreate() {
        },

        created() {
        },

        beforeMount() {
            this.$PrintLog(this.THIS_NAME + " : beforeMount");
        },

        mounted() {

            this.$PrintLog(this.THIS_NAME + " : mounted");
            this.init();

        },

        beforeUpdate() {
            this.$PrintLog(this.THIS_NAME + " : beforeUpdate");
        },

        updated() {
            this.$PrintLog(this.THIS_NAME + " : updated");
        },

        beforeDestroy() {
        },

        destroyed() {
        },
    };
</script>
